import { Navigate } from 'react-router-dom';
import { getUserLoggedIn } from '../utils/global_functions';

const ProtectedRoute = ({ children, ...props }) => {
    const objLoginSession = getUserLoggedIn();


   if(!objLoginSession && location.pathname === "/calculator"){
    return children
   }

    return (
        objLoginSession ? (
            children
        ) : (
            <Navigate to="/" replace />
        )
    );
};

export default ProtectedRoute;
